import { Option } from 'common/types';
import { MeetingBookingStatus } from 'generated-graphql/types';
import { calendarBookingStatusText } from 'modules/calendar/utils/calendarBookingUtils';
import { MeetingFilter } from './enums';

export const meetingOptions: Option[] = [
  ...[
    MeetingBookingStatus.Scheduled,
    MeetingBookingStatus.Rescheduled,
    MeetingBookingStatus.ReschedulingRequested,
    MeetingBookingStatus.Cancelled
  ].map((status) => ({
    value: status,
    label: calendarBookingStatusText[status]
  })),
  {
    value: MeetingFilter.NO_MEETING,
    label: 'No meeting'
  }
];
